import { render } from "./InformationPromoDetail.vue?vue&type=template&id=4263d3ca"
import script from "./InformationPromoDetail.vue?vue&type=script&lang=js"
export * from "./InformationPromoDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/admin.23paskal.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__